import React from 'react';
import SkillBlockRenderer from './SkillBlockRenderer';
import SensitivitySkillAdapter from '../adapters/SensitivitySkillAdapter';
import CalculatorSkillAdapter from '../adapters/CalculatorSkillAdapter';
import MiAnalysisSkillAdapter from '../adapters/MiAnalysisSkillAdapter';
import TrainingSkillAdapter from '../adapters/TrainingSkillAdapter';
import FavoritesSkillAdapter from '../adapters/FavoritesSkillAdapter';
import ProfileSettingsAdapter from '../adapters/ProfileSettingsAdapter';
import ProfilePlanAdapter from '../adapters/ProfilePlanAdapter';
import PurchaseProAdapter from '../adapters/PurchaseProAdapter';
import AdminPanelAdapter from '../adapters/AdminPanelAdapter';
import PartnerPanelAdapter from '../adapters/PartnerPanelAdapter';
import SupportCommunityAdapter from '../adapters/SupportCommunityAdapter';
import FallbackExpertAdapter from '../adapters/FallbackExpertAdapter';

// Mapa declarativo adapter → componente. O registry aponta para cá pelo nome.
const ADAPTERS = {
  SensitivitySkillAdapter,
  CalculatorSkillAdapter,
  MiAnalysisSkillAdapter,
  TrainingSkillAdapter,
  FavoritesSkillAdapter,
  ProfileSettingsAdapter,
  ProfilePlanAdapter,
  PurchaseProAdapter,
  AdminPanelAdapter,
  PartnerPanelAdapter,
  SupportCommunityAdapter,
  FallbackExpertAdapter
};

export default function CapabilityRenderer({ adapterKey, capabilityId, context, agent }) {
  const Adapter = ADAPTERS[adapterKey];
  if (!Adapter) return null;

  return (
    <SkillBlockRenderer capabilityId={capabilityId}>
      <Adapter agent={agent} context={{ ...context, capabilityId }} />
    </SkillBlockRenderer>
  );
}
